import api from '@/api/Api';
import { getAuthToken } from '@/utils/auth/tokenManager';
import type { EmailTemplate } from '@/types/emailTemplate';

export const emailTemplateService = {
  async uploadEmailTemplateAsset(file: File, token: string): Promise<{ fileUrl: string }> {
    return new Promise((resolve, reject) => {
      const workspaceId = localStorage.getItem('workspaceId');

      if (!workspaceId) {
        reject(new Error('Workspace ID not found'));
        return;
      }

      const formData = new FormData();
      formData.append('file', file);

      const xhr = new XMLHttpRequest();
      const url = `${api.defaults.baseURL}/email-templates/uploadEmailTemplateAssets?workspace_id=${workspaceId}`;

      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
          const progress = (event.loaded / event.total) * 100;
          // Dispatch a custom event that components can listen to
          window.dispatchEvent(new CustomEvent('emailTemplateAssetUploadProgress', {
            detail: { progress }
          }));
        }
      });

      xhr.addEventListener('load', () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          const response = JSON.parse(xhr.responseText);
          resolve(response.data);
        } else {
          reject(new Error('Upload failed'));
        }
      });

      xhr.addEventListener('error', () => {
        reject(new Error('Upload failed'));
      });

      xhr.open('POST', url);
      xhr.setRequestHeader('Authorization', token ? `Bearer ${token}` : '');
      xhr.send(formData);
    });
  },

  async getEmailTemplates() {
    const token = getAuthToken();
    const response = await api.get('/email-templates', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  async getEmailTemplate(id: string) {
    const token = getAuthToken();
    const response = await api.get(`/email-templates/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  async createEmailTemplate(data: Partial<EmailTemplate>) {
    const token = getAuthToken();
    const response = await api.post('/email-templates', data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  async updateEmailTemplate(id: string, data: Partial<EmailTemplate>) {
    const response = await api.put(`/email-templates/${id}`, data);
    return response.data;
  },

  async deleteEmailTemplate(id: string) {
    const token = getAuthToken();
    const response = await api.delete(`/email-templates/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },
};
